import { useState } from "react"
import supabase from "../../utils/subabaseClient"
import { useAuth } from "../../Contexts/AuthContext"

export default function useData(group_id) {
  const { user } = useAuth()

  const [title, setTitle] = useState("")
  const [amount, setAmount] = useState(0)
  const [adding, setAdding] = useState(false)
  const [done, setDone] = useState(false)

  const handleSubmit = async (event) => {
    event.preventDefault()
    setAdding(true)
    const { data, error } = await supabase
      .from("expenses")
      .insert({ title, amount, group_id, created_by: (user).id })
      .select()

    if (error) {
      console.error("Error creating expense:", error.message)
    } else {
      console.log("Expense created successfully!")
      setDone(true)
      setTitle("")
      setAmount(0)
    }

    setAdding(false)
  }

  return {
    title,
    setTitle,
    amount,
    setAmount,
    handleSubmit,
    adding,
    done,
    setDone,
  }
}
